import { Flex, Text } from "@chakra-ui/react";
import { EmptyState } from "@components";
import chatEmptyImage from "@assets/svg/icon-news-empty.svg";

const ChatEmptyState = () => {
  return (
    <Flex
      flex="1"
      direction="column"
      align="center"
      justify="center"
      gap="12px"
      py="14px"
    >
      <EmptyState
        imgSrc={chatEmptyImage}
        imgProps={{ width: "72px" }}
        text={"No messages yet.\nSay hello to your neighbors!"}
        textProps={{
          color: "dark.100",
          textAlign: "center",
          mt: "3",
          fontSize: "12px",
          lineHeight: "1.5",
          whiteSpace: "pre-line",
        }}
      />
      <Text fontSize="10px" color="dark.300" textAlign="center">
        Chat is cleared when the meeting ends
      </Text>
    </Flex>
  );
};

export default ChatEmptyState;
